import script from "./FAQViews.vue?vue&type=script&setup=true&lang=ts"
export * from "./FAQViews.vue?vue&type=script&setup=true&lang=ts"

import "./FAQViews.vue?vue&type=style&index=0&id=f81aa7aa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f81aa7aa"]])

export default __exports__